import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';

import './index.scss';

import searchIcon from '../../../../../../../assets/images/busca-preto.svg';
import TagOption from './TagOption';
import { TagActions } from '../../../../../../../store/actions/tags';

const TagsGraphicSearchInput = (props) => {
  const { botId, tags, selectedTags, setSelectedTags } = props;

  const searchWrapperRef = useRef(null);
  const [currentTagsSearch, setCurrentTagsSearch] = useState([]);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [isSelectedHidden, setIsSelectedHidden] = useState(true);

  /**
   * Add mouse click listener for close de dropdown menu and get the list of tags from bot
   */
  useEffect(() => {
    if (botId) {
      const { list } = props;
      list({ botId });
    }

    document.addEventListener('click', onClickOutsideComponent, false);
    return () => {
      document.removeEventListener('click', onClickOutsideComponent, false);
    };
  }, []);

  /**
   * Update the tags for selected list when the tags reference update
   */
  useEffect(() => {
    if (tags.bot.length > 0) {
      setCurrentTagsSearch(tags.bot);
    }
  }, [tags]);

  /**
   * Update the list of available tags for selected filter by search term updated
   */
  useEffect(() => {
    if (searchInputValue === '') {
      const newCurrentTagsSearch = formatListTagsAvailableForSelected();
      setCurrentTagsSearch(newCurrentTagsSearch);
    } else {
      formatCustomListTags();
    }
  }, [searchInputValue]);

  /**
   * Update the state of dropdown list of selectable tags
   */
  useEffect(() => {
    if (!isSelectedHidden) {
      setCurrentTagsSearch(formatListTagsAvailableForSelected());
    }
  }, [isSelectedHidden]);

  /**
   * Format the current list for a custom filtered by the search term
   */
  const formatCustomListTags = () => {
    const tagsList = formatListTagsAvailableForSelected();
    const filterList = _.filter(tagsList, (tag) => {
      const hasName =
        tag.name.toLowerCase().indexOf(searchInputValue.toLowerCase()) !== -1;

      if (hasName) {
        return tag;
      }
    });

    setCurrentTagsSearch(filterList);
  };

  /**
   * Format list for tags available for be selected and add on selectedTags list
   */
  const formatListTagsAvailableForSelected = () => {
    return _.filter(tags.bot, (tag) => {
      const hasTag = selectedTags.indexOf(tag);
      if (hasTag === -1) {
        return tag;
      }
    });
  };

  /**
   * Called when the user click on tag option
   */
  const onClickSearchTagInput = () => {
    setIsSelectedHidden(!isSelectedHidden);
  };

  /**
   * Called when user click outside from the extract dropdown
   * @param {Object} event event from mouse
   */
  const onClickOutsideComponent = (event) => {
    if (
      searchWrapperRef.current &&
      !searchWrapperRef.current.contains(event.target)
    ) {
      setIsSelectedHidden(true);
    }
  };

  /**
   * Called when tag is selected for add his reference on selectedTags list
   *
   * @param {object} tag tag object reference for add on selectedTags list
   */
  const onClickTagOption = (tag) => {
    const newSelectedTags = [...selectedTags];
    newSelectedTags.push(tag);
    setSelectedTags(newSelectedTags);

    const newCurrentTagsSearch = [...currentTagsSearch];
    const currentTagIndex = newCurrentTagsSearch.indexOf(tag);

    if (currentTagIndex !== -1) {
      newCurrentTagsSearch.splice(currentTagIndex, 1);
      setCurrentTagsSearch(newCurrentTagsSearch);
      setSearchInputValue('');
    }
  };

  /**
   * Called when search input change value
   *
   * @param {object} event event element invoked
   */
  const onChangeSearchInput = (event) => {
    const newSearchValue = event.target.value;
    setSearchInputValue(newSearchValue);
  };

  /**
   * Render the collect data period options to search
   */
  const renderTagOptions = () => {
    if (currentTagsSearch.length == 0) {
      return false;
    }
    return currentTagsSearch.map((tag) => {
      return (
        <TagOption
          key={`${tag._id}-component`}
          tag={tag}
          onClickTagOption={onClickTagOption}
          add={true}
        />
      );
    });
  };

  return (
    <div className="tags-report-select" ref={searchWrapperRef}>
      <div
        className="tags-report-options"
        onClick={() => onClickSearchTagInput()}
      >
        <img src={searchIcon} alt="Lupa" />
        <input
          id="tags-report-input"
          type="text"
          placeholder="Buscar tag"
          value={searchInputValue}
          onChange={onChangeSearchInput}
        />
      </div>
      <div
        id="dropdown"
        className="tags-report-select-dropdown"
        hidden={isSelectedHidden}
      >
        {renderTagOptions()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    tags: state.tags.tagsState.tags,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...TagActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TagsGraphicSearchInput)
);
